/**
 * Validates a value for a given input key
 * @param key Input name
 * @param value Value of the input
 * @returns
 */
function reducer(key: string, value: any): string | undefined {
    switch (key) {
        case 'date_end':
            if (value && typeof value !== 'number') return `${key} must be a number`
            break
        case 'date_start':
            if (value && typeof value !== 'number') return `${key} must be a number`
            break
        case 'selected_media':
            if (typeof value !== 'string') return `${key} must be a string`
            break
        case 'file':
            if (!(value instanceof Array)) return `${key} must be an array of files`
            break
        default:
            return undefined
    }
}

/**
 * For every input in a form, validate its value
 * @param values All inputs in the form
 * @returns An object with the error message for any failing input
 */
function promoValidate(values: Record<string, any>) {
    return {
        ...Object.keys(values).reduce((obj, k: string) => {
            const out = obj
            const error = reducer(k, values[k])

            if (error) {
                out[k] = error
            }

            return obj
        }, {} as Record<string, string | undefined>),
    }
}

const compareValues = (values: Record<string, any>) => {
    const out: any = {}
    const { date_end = '2359', date_start = '0000' } = values

    if (date_end && date_start && date_end <= date_start) {
        out.date_end = 'Must be later than end_time'
    }

    return out
}

const validate = (values: Record<string, any>) => ({
    ...compareValues(values),
    ...Object.keys(values).reduce((obj: Record<string, any>, k: string) => {
        const out = obj
        const error = reducer(k, values[k])
        if (error) out[k] = error
        return obj
    }, {}),
})

export default promoValidate

export { validate }
